import { useLockBodyScroll } from '../../hooks/useLockBodyScroll';
import {
  useToggleWithAnimation,
  UseToggleWithAnimationArgs,
  UseToggleWithAnimationReturn,
} from '../../hooks/useToggleWithAnimation';

export const useDrawer = (
  args: UseToggleWithAnimationArgs
): UseToggleWithAnimationReturn & { closed: boolean } => {
  const { state, ...rest } = useToggleWithAnimation(args);

  useLockBodyScroll({ state });

  return { state, ...rest, closed: state === 'closed' };
};
